import React, { useState } from "react";
import "./Blog.css";
// import theme from "../assets/theme.png";
import memorybox from "../assets/memorybox.jpeg";
import memory2 from "../assets/memory2.jpeg";
import jwt from "../assets/jwt.png";
import routing from "../assets/routing.png";
import vpn from "../assets/vpn.jfif";

const Blog = () => {
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [image, setImage] = useState(null);
  const [data, setData] = useState([
    {
      id: 1,
      imgSrc: routing,
      blogTitle: "React Routing vs Conventional Routing",
      link: "https://developer20.hashnode.dev/how-is-react-router-different-from-conventional-routing",
    },
    {
      id: 2,
      imgSrc: vpn,
      blogTitle: "VPN Technology A Private Network",
      link: "https://developer20.hashnode.dev/vpn-technology",
    },
    {
      id: 3,
      imgSrc: jwt,
      blogTitle: "JSON Web Tokens for authentication in NodeJS",
      link: "https://developer20.hashnode.dev/using-json-web-tokens-for-authentication-in-nodejs",
    },
    {
      id: 4,
      imgSrc:
        "https://th.bing.com/th/id/OIP.4WygbQZrH1ocDaABCQqlkQHaDf?pid=ImgDet&rs=1",
      blogTitle: "What is JSON in Javascript and how to work with JSON",
      link: "https://developer20.hashnode.dev/what-is-json-in-javascript-and-how-to-work-with-json",
    },
    {
      id: 5,
      imgSrc:
        "https://th.bing.com/th/id/OIP.4WygbQZrH1ocDaABCQqlkQHaDf?pid=ImgDet&rs=1",
      blogTitle: "What is JSON in Javascript and how to work with JSON",
      link: "https://developer20.hashnode.dev/what-is-json-in-javascript-and-how-to-work-with-json",
    },
    {
      id: 6,
      imgSrc:
        "https://th.bing.com/th/id/OIP.4WygbQZrH1ocDaABCQqlkQHaDf?pid=ImgDet&rs=1",
      blogTitle: "What is JSON in Javascript and how to work with JSON",
      link: "https://developer20.hashnode.dev/what-is-json-in-javascript-and-how-to-work-with-json",
    },
  ]);

  const onImageChange = (e) => {
    if (e.target.files) {
      setImage(URL.createObjectURL(e.target.files[0]));
    }
  };

  const addBlog = (e) => {
    e.preventDefault();
    let dataCopy = [...data];
    dataCopy.push({
      id: data.length + 1,
      imgSrc: image,
      blogTitle: title,
      link: link,
    });
    setData(dataCopy);
    setTitle("");
    setLink("");
    setImage(null);
  };

  return (
    <div>
      <div
        className="container"
        style={{ display: "flex", justifyContent: "space-evenly" }}
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 memorydiv">
            <h2 className="mainheading" style={{ marginTop: "30px" }}>
              AN APPLICATION TO STORE INDIVIDUAL MEMORIES.
            </h2>
            This application will preserve individual memories and allow them to
            revisit them whenever they desire. The project will also reduce the
            person's stress by examining his or her old recollections .
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 memorydivpart">
            <img src={memorybox} alt="memorybox" className="memoryimage" />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <img src={memory2} alt="memory2" className="memory2image" />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h2 className="mainheading" style={{ marginTop: "30px" }}>
              SHARE YOUR STORY WITH CONFIDENCE
            </h2>
            This application will preserve individual memories and allow them to
            revisit them whenever they desire. The project will also reduce the
            person's stress by examining his or her old recollections .
          </div>
        </div>
      </div>
      {/* <div class="container">
        <div
          class="row"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {data.map((blog) => {
            return (
              <div
                class="col-lg-4 col-md-4 col-sm-12"
                key={blog.id}
                className="blogset"
              >
                <div
                  class="card blog-card"
                  style={{
                    // width: "18rem",
                    // height: "22rem",
                    boxShadow: "0 0 15px -2px #444444",
                  }}
                >
                  <img
                    src={blog.imgSrc}
                    class="card-img-top"
                    alt="blog"
                    className="blogimageset"
                  />
                  <div class="card-body">
                    <h5 class="card-title">{blog.blogTitle}</h5>
                    <p class="card-text">
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </p>
                    <br />
                    <a
                      href={blog.link}
                      class="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fa-solid fa-arrow-right fa-xs"></i>
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div> */}
      <div class="container">
        <div class="row cards-section">
          {data.map((blog) => {
            return (
              <div
                class="col-lg-4 col-md-4 col-sm-12"
                key={blog.id}
                className="blogset"
              >
                <div
                  class="card"
                  style={{ boxShadow: "0 0 15px -2px #444444" }}
                >
                  <img
                    src={blog.imgSrc}
                    class="card-img-top"
                    alt="blog"
                    className="blogimageset"
                  />
                  <div class="card-body">
                    <h5 class="card-title">{blog.blogTitle}</h5>
                    <p class="card-text">
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </p>
                    <br />
                    <a
                      href={blog.link}
                      class="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fa-solid fa-arrow-right fa-xs"></i>
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="container">
        <div>
          <form className="form-group">
            <input
              class="form-control"
              type="file"
              onChange={onImageChange}
              id="formFile"
            />
            <br />
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder="Title Goes Here..."
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <br />
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder="Link To Blog Goes Here..."
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
            <br />
            <button className="btn btn-outline-success" onClick={addBlog}>
              Add
            </button>
          </form>
          <br />
          <hr />
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <h6>Post Categories</h6>
            <a href="www.google.com" target="_blank">
              Releases
            </a>
            <br />
            <a href="www.google.com" target="_blank">
              Tweet
            </a>
            <br />
            <a href="www.google.com" target="_blank">
              Tips
            </a>
            <br />
          </div>
          <div className="col-lg-4">
            <h6>Join Newsletter</h6>
            <br />
            <button
              style={{
                borderRadius: "20px",
                backgroundColor: "orange",
                color: "white",
              }}
            >
              Subscribe
            </button>
            <br />
          </div>
          <div className="col-lg-4">
            <h2>Follow Momento</h2>
            <div className="container social-media">
              <span>
                <i class="fa-brands fa-twitter fa-2x  "></i>
              </span>
              <span>
                <i class="fa-brands fa-facebook fa-2x "></i>
              </span>
              <span>
                <i class="fa-brands fa-instagram fa-2.5x"></i>
              </span>
            </div>
          </div>
          <div className="container">
            <div className="row" style={{ justifyContent: "center" }}>
              <h2> FROM ALL THE TEAM OF MOMEMTO , THANK YOU !!!</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
